module.exports = __webpack_public_path__ + "static/media/TG.b5aba65b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TG.svg
// module id = 2272
// module chunks = 7